import Moveable from "./Moveable";
import { PROPERTIES, EVENTS } from "./consts";

(Moveable as any).PROPERTIES = PROPERTIES;
(Moveable as any).EVENTS = EVENTS;

export default Moveable;
